// removed by extract-text-webpack-plugin
module.exports = {"colorBar":"colorBar___3-yIz","extentBar":"extentBar___BZzTR","colorBarItem":"colorBarItem___1CJgK","extentBarItem":"extentBarItem___2srYh","srOnly":"srOnly___3HH5M"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MapLegend/CustomLegend.module.scss
// module id = 2089
// module chunks = 0